import { render } from "./Confirmation.vue?vue&type=template&id=cd3d589a"
import script from "./Confirmation.vue?vue&type=script&setup=true&lang=js"
export * from "./Confirmation.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/forge/retail.digitalhq.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Bread/Resources/ui/Components/Elements/Modals/Confirmation.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "cd3d589a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('cd3d589a', __exports__)) {
    api.reload('cd3d589a', __exports__)
  }
  
  module.hot.accept("./Confirmation.vue?vue&type=template&id=cd3d589a", () => {
    api.rerender('cd3d589a', render)
  })

}


export default __exports__